module.exports = __webpack_public_path__ + "static/blog63-eeace25338be409d2dfb9b0cdeb6a2c6.png";